import { makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) => ({
  text: {
    marginLeft: theme.spacing(1),
  },
}));
